import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

export const SUPPORTED_LANGUAGES = ["ru", "en", "et", "es"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const fallbackLng: SupportedLanguage = "en";

if (!i18n.isInitialized) {
    i18n.use(HttpBackend)
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
            fallbackLng,
            supportedLngs: SUPPORTED_LANGUAGES,
            nonExplicitSupportedLngs: true,
            defaultNS: "translation",
            ns: ["translation"],
            backend: {
                loadPath: "/locales/{{lng}}/{{ns}}.json",
            },
            detection: {
                order: ["querystring", "localStorage", "sessionStorage", "navigator", "cookie", "htmlTag"],
                caches: ["localStorage"],
            },
            react: {
                useSuspense: true,
            },
            interpolation: {
                escapeValue: false,
            },
        });
}

export const getCurrentLanguage = (): SupportedLanguage => {
    const currentLanguage = (i18n.resolvedLanguage || i18n.language || fallbackLng).toLowerCase();
    const normalizedLanguage = currentLanguage.split("-")[0] as SupportedLanguage;

    return SUPPORTED_LANGUAGES.includes(normalizedLanguage) ? normalizedLanguage : fallbackLng;
};

export default i18n;
